import uniqueId from 'lodash/uniqueId';
import axios from 'axios';

function saveUserPreferences(key, value) {
  return axios
    .post('/infrastructure/userUIPref/save', { key, value: JSON.stringify(value) })
    .then(({ data: { data } }) => data);
}

export default (data) => {
  // From R7 to R8 Account Summary is no longer a default widget for the Dashboard.
  // User's who changed their Dashboard widgets in R7 have a user preference with an out-of-date default account summary widget
  const userWidgets = JSON.parse(data?.data?.value || '[]');
  const accountSummaryWidget = userWidgets.find((widget) => widget.widgetCode === 'ACCTSUMMARY');
  const financialOverviewWidget = userWidgets.find(
    (widget) => widget.widgetCode === 'FINOVERVIEW'
  );
  // If this flag does not exist then remove
  if (accountSummaryWidget && accountSummaryWidget.manuallyAdded === undefined) {
    // Check if Financial Overview widget exists, if not then replace Account Summary widget with Financial Overview
    // If the user already has a financial overview widget then just remove account summary
    if (financialOverviewWidget) {
      const updatedUserWidgets = userWidgets
        .filter((widget) => widget.widgetCode !== 'ACCTSUMMARY')
        .sort((a, b) => a.rowNumber - b.rowNumber);
      saveUserPreferences('DASHBOARD', updatedUserWidgets);
      return {
        success: true,
        result: {
          info: 'Request processed successfully.'
        },
        data: {
          key: '',
          value: JSON.stringify(updatedUserWidgets)
        }
      };
    }
    // If user does not have a financial overview widget but has an out-of-date account summary widget then replace
    const updatedUserWidgets = userWidgets
      .map((widget) => {
        if (widget.widgetCode === 'ACCTSUMMARY') {
          return {
            allowedSizes: 'S,L',
            dateAdded: new Date(),
            manuallyAdded: true,
            uniqueId: `FINOVERVIEW_${uniqueId()}`,
            widgetCode: 'FINOVERVIEW',
            widgetName: 'Financial Overview'
          };
        }
        return widget;
      })
      .sort((a, b) => a.rowNumber - b.rowNumber);
    saveUserPreferences('DASHBOARD', updatedUserWidgets);
    return {
      success: true,
      result: {
        info: 'Request processed successfully.'
      },
      data: {
        key: '',
        value: JSON.stringify(updatedUserWidgets)
      }
    };
  }
  return data;
};
